function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M24400.338 18978.332a1.334 1.334 0 0 1-1.332-1.334v-8.383a.333.333 0 0 1 .549-.254c1.988 1.686 5.479 4.652 6.52 5.592a1.35 1.35 0 0 0 1.861 0c.979-.881 4.086-3.527 6.521-5.592a.333.333 0 0 1 .355-.049.336.336 0 0 1 .193.3v8.388a1.335 1.335 0 0 1-1.334 1.334zm6.184-6.209c-1.133-1.02-4.986-4.291-7.182-6.15a.334.334 0 0 1-.047-.461 1.323 1.323 0 0 1 1.045-.514h13.334a1.327 1.327 0 0 1 1.047.514.336.336 0 0 1-.047.461c-2.2 1.859-6.049 5.131-7.184 6.152a.666.666 0 0 1-.967 0z",
  transform: "translate(-24395.004 -18959.666)"
});

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.0e0f75f8.svg";
export { ForwardRef as ReactComponent };